import { render, staticRenderFns } from "./VTextarea.vue?vue&type=template&id=b7771a46&scoped=true&lang=pug&"
import script from "./VTextarea.vue?vue&type=script&lang=js&"
export * from "./VTextarea.vue?vue&type=script&lang=js&"
import style0 from "./VTextarea.vue?vue&type=style&index=0&id=b7771a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7771a46",
  null
  
)

export default component.exports